import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Form, Input } from 'antd';
import { useState } from 'react';
import { useAppDispatch } from '@/app/store/hooks';
import { phoneLoginByPwd } from '@/features/auth/api/authApi';
import { loginSucceeded } from '@/entities/session/model/sessionSlice';
import { storeAuthToken } from '@/entities/session/model/authStorage';
import { AgreementField } from '@/features/auth/ui/AgreementField';
import { normalizeApiError } from '@/shared/api/errors';
import { suppressApiErrorToast } from '@/shared/api/httpClient';
/** 手机号格式，与后端 DTO 校验保持一致。 */
const PHONE_PATTERN = /^1[3-9]\d{9}$/;
/** 渲染手机号密码登录表单，仅限已设置密码的账号使用。 */
export function PasswordLoginForm(props) {
    const [form] = Form.useForm();
    const dispatch = useAppDispatch();
    const [errorText, setErrorText] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    /** 提交密码登录，成功后保存令牌并更新会话状态。 */
    async function handleFinish(values) {
        setSubmitting(true);
        setErrorText(null);
        try {
            const result = await phoneLoginByPwd({
                phone: values.phone.trim(),
                password: values.password,
            });
            storeAuthToken(result.token);
            dispatch(loginSucceeded(result.user));
        }
        catch (error) {
            /** 失败文案就地展示在表单里，同步抑制统一出口，避免同一次失败弹两处。 */
            setErrorText(normalizeApiError(error).message);
            suppressApiErrorToast(error);
        }
        finally {
            setSubmitting(false);
        }
    }
    return (_jsxs(Form, { className: "auth-form", form: form, layout: "vertical", requiredMark: false, onFinish: (values) => {
            void handleFinish(values);
        }, children: [errorText && (_jsx("p", { className: "auth-form__error", role: "alert", children: errorText })), _jsx(Form.Item, { label: "\u624B\u673A\u53F7", name: "phone", rules: [
                    { required: true, message: '请输入手机号' },
                    { pattern: PHONE_PATTERN, message: '手机号格式不正确' },
                ], children: _jsx(Input, { inputMode: "numeric", maxLength: 11, placeholder: "\u8BF7\u8F93\u5165\u624B\u673A\u53F7", autoComplete: "tel" }) }), _jsx(Form.Item, { label: "\u5BC6\u7801", name: "password", rules: [
                    { required: true, message: '请输入密码' },
                    { min: 6, max: 32, message: '密码长度需在 6-32 位之间' },
                ], children: _jsx(Input.Password, { placeholder: "\u8BF7\u8F93\u5165\u767B\u5F55\u5BC6\u7801", autoComplete: "current-password" }) }), _jsx(AgreementField, { accepted: props.agreementAccepted, onAcceptedChange: props.onAgreementChange }), _jsx(Button, { className: "auth-form__submit", type: "primary", htmlType: "submit", block: true, disabled: !props.agreementAccepted, loading: submitting, children: "\u767B\u5F55" }), _jsx("div", { className: "auth-form__links", children: _jsx("button", { className: "auth-form__link", type: "button", onClick: props.onForgotPassword, children: "\u5FD8\u8BB0\u5BC6\u7801\uFF1F" }) })] }));
}
